module.exports = __webpack_public_path__ + "img/bal-des-vampires.c3132897.jpg";